import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-路径 15",
  "use": "icon-路径 15-usage",
  "viewBox": "0 0 13.321 13.321",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.321 13.321\" id=\"icon-路径 15\"><defs><style>#icon-路径 15 .a{fill:#cbcbc9;}</style></defs><path class=\"a\" d=\"M120.68,116.526a4.5,4.5,0,1,1-1.757.355,4.5,4.5,0,0,1,1.757-.355m0-1.042a5.558,5.558,0,1,0,5.558,5.558A5.558,5.558,0,0,0,120.68,115.484Zm7.242,13.321a.518.518,0,0,1-.368-.153l-2.64-2.64a.521.521,0,0,1,.737-.737l2.64,2.64a.521.521,0,0,1-.368.89Zm0,0\" transform=\"translate(-115.122 -115.484)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol